<app-toolbar></app-toolbar>

<app-loader></app-loader>

<div class="content">
	<router-outlet></router-outlet>
</div>
